import HTTP from '../common/http-common';

const END_POINT = '/service';

const isExistServiceCode = (serviceCode, serviceId) => HTTP.get(END_POINT +  "/exist/" + serviceCode + "/" + serviceId);
const listService = () => HTTP.get(END_POINT);

const insertService = (data) => HTTP.post(END_POINT, {
    serviceCode: data.serviceCode,
    serviceName: data.serviceName
});
const updateService = (data) => HTTP.post(END_POINT + "/" + data.serviceId, {
    serviceCode: data.serviceCode,
    serviceName: data.serviceName
});

const deleteService = (serviceId) => HTTP.delete(END_POINT + "/" + serviceId);

export {
    isExistServiceCode,
    listService,
    insertService,
    updateService,
    deleteService
}